import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Grid } from '@material-ui/core';

import axios from '../../config/axios';

import DetailData from '../../pages/DetailAppointment/components/DetailData';
import { get_appointment_details } from '../../api/API';
const useStyles = makeStyles(() => ({
    root: {
        padding: '24px',
    },
}));

// export default function DetailAppointment(props) {
//     const { className, ...rest } = props;

//     const classes = useStyles();
//     const [appointments, setAppointment] = useState();
  
//     useEffect(() => {
//       let mounted = true;
  
//       const fetchAppointment = () => {
//         axios.get('/api/admindetails/1').then(response => {
//             if (mounted) {
//                 setAppointment(response.data.appointmentdetail);
//             }
//         });
//     };
  
//     fetchAppointment();
  
//         return () => {
//             mounted = false;
//         };
//     }, []);
  
//     if (!appointments) {
//         return null;
//     }

//     return (
//         <Grid
//             {...rest}
//             className={clsx(classes.root, className)}
//             container
//             spacing={3}
//         >
//             <Grid
//                 item
//                 lg={6}
//                 md={6}
//                 xl={4}
//                 xs={12}
//             >
//                 <DetailData appointments={appointments} />
//             </Grid>
            
//         </Grid>
//     )
// }


export default class DetailAppointment extends React.Component {
    
    constructor(props){
        super(props);
        // console.log( this.props.match );

        this.state = {
            appointments: null,
            appointment_id: props.appointment_id
        }
    }
  
    async get_data(){
        const postparam = {
            appointment_id: this.state.appointment_id
        }; 
    
        var json = await get_appointment_details(postparam);
        if(json.status){
            console.log(json); 
            this.setState({...this.state, appointments : json.data });
        }
    }
 
    componentDidMount(){
        this.get_data();
    }

    render(){
        return (
            <Grid
                {...this.props}
                className={clsx(this.props.classes.root, this.props.className)}
                container
                spacing={3}
            >
                <Grid
                    item
                    lg={6}
                    md={6}
                    xl={4}
                    xs={12}
                >
                { this.state.appointments ? 
                <DetailData classes={this.props.classes} appointments={this.state.appointments} /> : ''
                }
                </Grid>
                
            </Grid>
        )
    }
}

